import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DatabaseCollectionProvider, DatabaseService } from "@library/core-database/src/public_api";
import { SurveyModel } from "@library/core-models";
import { DATABASE_COLLECTIONS } from "@library/core-models/src/schema";
import { DeviceNotificationService } from "@library/plugin-device-notification/src/public_api";
import { AppSettings } from "@library/plugin-settings/src/public_api";
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TrialService {

  constructor(
    private httpClient: HttpClient,
    private settings: AppSettings,
    private databaseService: DatabaseService,
    private notificationService: DeviceNotificationService,
    private collectionProvider: DatabaseCollectionProvider){}

  async getTrialToken(): Promise<any> {
    const accessToken = await this.httpClient.get<any>('https://mia-trial.de-rena.de/api/coaches/create-trial-access').toPromise();

    return accessToken;
  }

  startTrialTimeInterval() {
    if(!this.hasTrialExpired()) {
      setInterval(() => {
        if(this.hasTrialExpired()) {
          this.stopTrial();
        }
      }, 180000);
    } else {
      this.stopTrial();
    }
  }

  hasTrialExpired(): boolean {
    const startDate = moment(this.settings.get('trial-start'));
    let now = moment();

    // 14 days
    if(now.diff(startDate, 'hours') > 336) {
      return true;
    } else {
      return false;
    }
  }

  private async stopTrial() {
    await this.removeTrialExpirationNotifications();
    await this.resetSurveyFrequencyInterval();
    this.settings.unset('trial-notifications');
    this.settings.set('trial-expired', true);
    setTimeout(() => {
      this.databaseService.disconnect().then(() => location.reload());
    }, 300);
  }

  async createTrialExpirationNotifications() {
    const ready = await this.notificationService.setup();
    if (ready) {
      let notificationIds = [];
      for (let i = 1; i < 14; i++) {
        let date = new Date();
        date.setHours(12);
        date.setMinutes(0);
        let notificationDate = moment(date).add(i, 'days');
        let id = this.notificationService.schedule('MiA Testzeitraum', `Dein MiA Testzeitraum läuft in ${(14 - i)} Tage ab.`, true, notificationDate);
        notificationIds.push(id);
      }

      this.settings.set('trial-notifications', notificationIds);
    }
  }

  async removeTrialExpirationNotifications() {
    await this.notificationService.setup();
    const ids = this.settings.get('trial-notifications');
    if (!ids || !ids.length) {
      return;
    }

    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      await this.notificationService.remove(id);
    }
  }

  async resetSurveyFrequencyInterval() {
    const surveyCollection = this.collectionProvider.use<SurveyModel>(DATABASE_COLLECTIONS.SurveyCollection);

    const doc = await surveyCollection.findOne().exec();

    if(!doc) {
      return;
    }

    const survey = (doc.toJSON() as SurveyModel);

    survey.interval = 2;
    survey.frequency = 'WEEKLY';
    survey.until = moment().add(6, 'months').toISOString();

    await surveyCollection.atomicUpsert(survey);
  }
}
